import React, { useEffect } from "react";
import siteText from "../assets/siteText.json";

// Only push page view once per page load
let contactPageViewPushed = false;

function Contact() {
  useEffect(() => {
    // Push page view event to GTM dataLayer if not already pushed
    if (!contactPageViewPushed && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'pageView',
        page: window.location.pathname
      });
      contactPageViewPushed = true;
    }
  }, []);

  return (
    <div className="container">
      <h2 style={{ marginTop: '2rem' }}>{siteText.contact.header}</h2>
      <p>
        <strong>{siteText.contact.emailLabel}</strong> <a href={`mailto:${siteText.contact.email}`}>{siteText.contact.email}</a>
      </p>

      <h3 style={{ marginTop: '2rem' }}>{siteText.contact.directionsHeader}</h3>
      <p>
        {siteText.contact.directions}
      </p>
      <iframe
        title="Fig Tree Cottage Location"
        src="https://www.openstreetmap.org/export/embed.html?bbox=-2.058778%2C50.633389%2C-2.048778%2C50.635389&layer=mapnik&marker=50.634389,-2.053778"
        style={{ marginTop: '2rem', width: "100%", height: "300px", border: 0, borderRadius: "8px" }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </div>
  );
}

export default Contact;
